export const searchOptions = [
  {
    value: "barcode",
    title: "Barcode",
  },
  {
    value: "serial",
    title: "Serial Number",
  },
];
